import React from 'react'
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
    BooleanField,
    NumberField,
} from 'react-admin'


export const SistemaElectricoShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <NumberField source="id" />
            <TextField source="name" />
            <TextField source="subsystem_name" />
            <TextField source="subsystem_code" />
            <BooleanField source="active" />
            <ReferenceField source="sistema_interconectado" reference="sistemas-interconectados">
                <TextField source="name" />
            </ReferenceField>
        </SimpleShowLayout>
    </Show>
);
